import { createFileRoute } from '@tanstack/react-router';
import { NotificationSettings } from '../-components/NotificationSettings';
import { useContext } from 'react';
import { ProfileContext } from '../route';
import { CompanyProfileType } from '@/api/backend/types';

export const Route = createFileRoute('/_auth/profile/company/_layout/notification-settings')({
  component: RouteComponent,
});

function RouteComponent() {
  const { profile } = useContext(ProfileContext);
  const companyProfile = profile as CompanyProfileType;

  return <NotificationSettings profile={companyProfile} />;
}
